import analytics from "../../analytics_v3/dist/analytics";
import { setSearchParams } from "./refs-setting-logic.js";
import { asyncBufferEvents } from "../../analytics_v3/dist/utils";
import { Bies } from "../../analytics_v3/dist/bies";
import { Environment } from "../../analytics_v3/dist/types/bies";

const urlParams = new URLSearchParams(window.location.search);
// Create bi event server analytic instance
const biesConfig = {
  biAppId: "chaton.desktop",
    environment: process.env.NODE_ENV !== "production" ? Environment.STAGING : Environment.PRODUCTION,

  setParamsTracker: true,
};

Bies.createInstance(biesConfig).then((biesInstance) => {
  window.bies = biesInstance;


  setTimeout(() => {
    let fbp, ttp, external_id;

    if (window._capi) {
      const capiParams = window._capi?.getCapiParams();
      fbp = capiParams?.fbp;
      external_id = capiParams?.external_id;
    }
    if (window._tapi) {
      const tapiParams = window._tapi?.getTapiParams();
      ttp = tapiParams?.ttp;
    }

    const payload = {};

    if (fbp) payload.fbp = fbp;
    if (ttp) payload.ttp = ttp;
    if (external_id) payload.external_id = external_id;
    biesInstance?.updateCustomParameters(payload);
  }, 5000);
});

// Analytics
const userData = {};

const externalId = urlParams.get("externalId") || urlParams.get("external_id");
const adgroup = urlParams.get('adgroup');

const config = {
  projectName: "chaton",
  landingName: "web_06",
  userData,
  isStaging: process.env.NODE_ENV !== 'production',
  sources: ["amplitude"],
  amplitudeDefaultParams: {
    landing_url: location.hostname + location.pathname,
    full_url: location.href,
  },
  amplitudeConfig: {
    onetrustTracking: true,
    userProperties: {
      adgroup 
    }
  },
};
if (externalId) {
  config.externalId = externalId
}
const sendCustomEventAnalytics = asyncBufferEvents(analytics.bind(null, config));

const hasFirstLaunchWebsite = localStorage.getItem(`hasFirstLaunchWebsite_${config.landingName}`);

if (!(hasFirstLaunchWebsite && JSON.parse(hasFirstLaunchWebsite))) {
  sendCustomEventAnalytics({
    event: "first_launch",
  });
  localStorage.setItem(`hasFirstLaunchWebsite_${config.landingName}`, JSON.stringify(true));
}

setAnalyticsEvent(".cta-button a", "get_started_tap");
setAnalyticsEvent(".introduction__cta-button a", "get_started_tap");
setAnalyticsEvent(".sign-in", "sign_in_tap");
setAnalyticsEvent(".sign-up", "sign_up_tap");
setAnalyticsEvent(".gdpr-links__support", "send_request_tap");

function setAnalyticsEvent(selector, eventName, amplitude = false) {
  const elements = document.querySelectorAll(selector);
  if (elements?.length > 0) {
    elements.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        setSearchParams();
        const link = e.currentTarget.href
        sendCustomEventAnalytics({
          event: eventName,
          amplitudeOnly: amplitude,
        });
        setTimeout(() => {
          window.location.href = link;
        }, 1400);
      });
    });
  }
}

export { sendCustomEventAnalytics };
